import axios from "axios";
import { config } from "../config";

const API_URL = config.API_URL;

const getAllUsers = () => {
    return axios.post(`${API_URL}getuserlist`);
}

const getReport = (data) => {
    return axios.post(`${API_URL}getreport`, data);
}

export default {
    getReport,
    getAllUsers
}